import React, { useState, useEffect } from "react";
import { PostApi, GetApi, PutApi, getProfCliente, getDocCliente } from "../../services/auth.js";
import { Loading } from "../../helpers";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "../../componentes/ModalLegacy";
import { Cont } from "./styles";
import { Card, CardBody, Grid, Section, InputContainer, FormLabel, Alert, Container, CardFooter, CardHeader} from "uikit-react";
import { DateFormatTNew, visible, mascaraCPF, validaCPF } from "../../services/funcoes";
import ReactPaginate from 'react-paginate';
import Select from 'react-select'
import InputMask from 'react-input-mask';
import Swal from 'sweetalert2';

const Usuarios = () => {

  const documento = getDocCliente();
  const profissao = getProfCliente();
  const ListaStatus = [
    { value: 2476, label: 'Ativo' },
    { value: 23013, label: 'Pré-Cadastro' },
    { value: 6387, label: 'Bloqueado' }
  ];
  const [ListaUsuario, setListaUsuario] = useState(false);
  const [NomeFiltro, setNomeFiltro] = useState("");
  const [StatusFiltro, setStatusFiltro] = useState(null);
  const [TipoFiltro, setTipoFiltro] = useState(null);
  const [DataCadInicio, setDataCadInicio] = useState("");
  const [DataCadTermino, setDataCadTermino] = useState("");
  const [CPFFiltro, setCPFFiltro] = useState("");
  const [ModalAlteraStatus, setModalAlteraStatus] = useState(false);
  const [NomeUsuarioAlteraStatus, setNomeUsuarioAlteraStatus] = useState("");
  const [DadosUsuario, setDadosUsuario] = useState("");
  const [ModalCadastroUsuario, setModalCadastroUsuario] = useState(false);
  const [DadosCadastro, setDadosCadastro] = useState({});
  const [ListaTipo, setListaTipo] = useState([]);
  const [LoadingExportar, setLoadingExportar] = useState(false);

  //mensagem 
  const [mensagem, Setmensagem] = useState("Nenhuma informação encontrada. Por favor, verifique o filtro aplicado e tente novamente.");

  //Alert
  const [msg, SetMsg] = useState("");
  const [time, SetTime] = useState("");
  const [color, SetColor] = useState(""); //sucess, danger, warning
  const [AlertMsg, SetAlertMsg] = useState(false); 

  //Paginação
  const [itensPerPage, SetItensPerPage] = useState(25);
  const [currentPage, SetCurrentPage] = useState(1);
  const [pageCount, SetPageCount] = useState(0);
  const [pageTotal, SePageTotal] = useState(0);

  const MudaPaginaItens = async (e) => {  
    if(!isNaN(e.nextSelectedPage+1)){      
      SetCurrentPage(e.nextSelectedPage+1)
    }
  }; 

  useEffect(() => {
    if (profissao !== "6005") { window.location.href = "/admin"; }
    GetListaUsuarios();
  },[currentPage, itensPerPage]);  
  
  useEffect(() => {  
    window.scrollTo(0, 0); 
  },[currentPage, itensPerPage]);
  
  useEffect(() => {  
    GetListaTipos();
  },[]);
  
  const GetListaTipos = async () => {
    const response = await GetApi('Cliente/ListaEspecificacoes?tipo=2900');
    if (response.status === 200) {
      setListaTipo(response.data.dados);    
    }    
  };
  
  const GetListaUsuarios = async () => {  
    setListaUsuario(false);

    var FiltrosURL = "";
    if(NomeFiltro){
      FiltrosURL = FiltrosURL + "Nome=" + NomeFiltro.trim() + "&";
    }
    if(StatusFiltro){
      FiltrosURL = FiltrosURL + "StatusId=" + StatusFiltro.value + "&";
    }
    if(TipoFiltro){
      FiltrosURL = FiltrosURL + "Tipo=" + TipoFiltro.value + "&";
    }
    if(DataCadInicio){
      FiltrosURL = FiltrosURL + "DataCadInicial=" + DataCadInicio + "&";
    }
    if(DataCadTermino){
      FiltrosURL = FiltrosURL + "DataCadFinal=" + DataCadTermino + "&";
    }
    if(CPFFiltro){
      FiltrosURL = FiltrosURL + "Documento=" + CPFFiltro.replace(/\D/g, "") + "&";
    }

    const response = await GetApi('Admin/?' + FiltrosURL + 'Pagina=' + currentPage + '&TamanhoPagina=' + itensPerPage );
    if (response.status === 200) {
      setListaUsuario(response.data.usuarios);
			SetPageCount(Math.ceil(response.data.totalRegistros / itensPerPage));
			SePageTotal(response.data.totalRegistros)
    } else {
      setListaUsuario([])
      SetTime(4000);
      SetMsg(response.data.mensagem);
      SetColor("danger");
      SetAlertMsg(true);
    }     
    
  };

  const AbreModalStatusUsuario = async (dados) => {    
    console.log("🚀 ~ AlterarStatusUsuario ~ dados:", dados);
    setNomeUsuarioAlteraStatus(dados.nome);
    setDadosUsuario(dados);
    setModalAlteraStatus(true);
  };

  const FechaModalStatusUsuario = () => {    
    setNomeUsuarioAlteraStatus("");
    setDadosUsuario("");
    setModalAlteraStatus(false);
  };

  const AlterarStatusUsuario = async (dados) => {
    var dados = {
      entCod: dados.entCod
    }
    const response = await PutApi('Admin/status', dados);
    if (response.status === 200) {
      GetListaUsuarios();
      SetTime(4000);
      SetMsg(response.data.mensagem);
      SetColor("success");
      SetAlertMsg(true);
      setModalAlteraStatus(false);
    } else {
      SetTime(4000);
      SetMsg(response.data.mensagem);
      SetColor("danger");
      SetAlertMsg(true);
      setModalAlteraStatus(false);
    }
  };

  const AbreModalCadastroUsuario = () => {
    setDadosCadastro(null);
    setModalCadastroUsuario(true);
  };

  const FechaModalCadastroUsuario = () => {
    setDadosCadastro(null);
    setModalCadastroUsuario(false);
  };

  const CadastrarUsuario = async () => {

		const VerificaEmail = /^[a-zA-Z0-9._%+-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;

    if(!DadosCadastro?.profissao){
			Swal.fire({
				icon: "warning",
				title: "Atenção!",
				text: "Por favor, informe o tipo de cadastro.",
			});
			return;
    }
    if(!DadosCadastro?.nome){
			Swal.fire({
				icon: "warning",
				title: "Atenção!",
				text: "Por favor, informe um nome.",
			});
      return;
    }
    if(validaCPF(DadosCadastro?.cpf) === false){
			Swal.fire({
				icon: "warning",
				title: "Atenção!",
				text: "Por favor, informe um CPF válido.",
			});
      return;
    }
    if(!DadosCadastro?.email){
			Swal.fire({
				icon: "warning",
				title: "Atenção!",
				text: "Por favor, informe um e-mail.",
			});
      return;
    }
    if(!VerificaEmail.test(DadosCadastro?.email)) {
			Swal.fire({
				icon: "warning",
				title: "Atenção!",
				text: "Você precisa informar um e-mail válido. Exemplo: nome@dominio.com.",
			});
			return;
		}
    if(!DadosCadastro?.telefone || DadosCadastro?.telefone.length < 11){
			Swal.fire({
				icon: "warning",
				title: "Atenção!",
				text: "Por favor, informe um telefone válido.",
			});
      return;
    }

		visible('btn-envia-formulario-loading');
    visible('btn-envia-formulario');

    var _Telefone = DadosCadastro?.telefone.replace(/\D/g, "");
    var DDDTelefone = _Telefone.substring(0, 2);
    var Telefone = _Telefone.substring(2);

    var dados = {
      nome: DadosCadastro?.nome,
      cpf: DadosCadastro?.cpf.replace(/\D/g, ""),
      email: DadosCadastro?.email,
      dddCelular: Number(DDDTelefone),
      celular: Number(Telefone),
      profissaoId: DadosCadastro?.profissao,
      origem: 6232
    }

    const response = await PostApi('Admin', dados);
    if (response.status === 200) {
      GetListaUsuarios();
      SetTime(4000);
      SetMsg(response.data.mensagem);
      SetColor("success");
      SetAlertMsg(true);
      setModalCadastroUsuario(false);
      visible('btn-envia-formulario-loading');
      visible('btn-envia-formulario');
    } else {
      SetTime(4000);
      SetMsg(response.data.mensagem);
      SetColor("danger");
      SetAlertMsg(true);
      setModalCadastroUsuario(false);
      visible('btn-envia-formulario-loading');
      visible('btn-envia-formulario');
    }
  };
  
  const ExportarDados = async () => {

    var FiltrosURL = "";
    if(NomeFiltro){
      FiltrosURL = FiltrosURL + "Nome=" + NomeFiltro.trim() + "&";
    }
    if(StatusFiltro){
      FiltrosURL = FiltrosURL + "StatusId=" + StatusFiltro.value + "&";
    }
    if(TipoFiltro){
      FiltrosURL = FiltrosURL + "Tipo=" + TipoFiltro.value + "&";
    }
    if(DataCadInicio){
      FiltrosURL = FiltrosURL + "DataCadInicial=" + DataCadInicio + "&";
    }
    if(DataCadTermino){
      FiltrosURL = FiltrosURL + "DataCadFinal=" + DataCadTermino + "&";
    }
    if(CPFFiltro){
      FiltrosURL = FiltrosURL + "Documento=" + CPFFiltro.replace(/\D/g, "") + "&";
    }

    setLoadingExportar(true);
    const response = await GetApi('Admin/excel?' + FiltrosURL + 'Pagina=' + currentPage + '&TamanhoPagina=' + itensPerPage );
    if (response.status === 200) {

    try {

      const base64 = response.data.arquivoExcel;
      const binaryString = window.atob(base64);
      const byteNumbers = new Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) { byteNumbers[i] = binaryString.charCodeAt(i); }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Usuarios.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);

      SetTime(4000);
      SetMsg("Exportação concluída com sucesso!");
      SetColor("success");
      SetAlertMsg(true);
      setLoadingExportar(false);
    } catch (err) {
      console.error("Erro ao processar o Excel:", err);
      SetMsg("Erro ao processar o arquivo Excel.");
      SetColor("danger");
      SetAlertMsg(true);
      setLoadingExportar(false);
    }

      SetTime(4000);
      SetMsg("Exportação concluída com sucesso!");
      SetColor("success");
      SetAlertMsg(true);
      setLoadingExportar(false);
    } else {
      setLoadingExportar(false);
      SetTime(4000);
      SetMsg(response.data.mensagem);
      SetColor("danger");
      SetAlertMsg(true);
    }
  };

  return (
    <Cont>    

      <Container size="expand" className="content-padder content-padder-inative" id="padder" >            
        <main className="uk-section">
          <Section className="uk-container uk-container-xlarge">  

              <Grid className="uk-flex uk-flex-middle uk-margin-medium">                
                <Section className="uk-width-expand">
                  <Section className="uk-inline">
                    <a className="uk-link-heading uk-flex uk-flex-middle">
                        <h4 className="uk-link-toggle uk-text-bold uk-margin-remove">
                          Usuários
                        </h4>
                        {/* <span uk-icon="icon: menu-down"></span> */}
                    </a>
                  </Section>
                </Section>
              </Grid>  
                    
              {/* FILTROS */}
              <Card className="uk-margin-medium-bottom">
                <CardBody>
                  <Grid className="uk-grid-small">                      
                
                    <Section className="uk-width-1-4@m">
                      <FormLabel className="uk-form-label">Nome</FormLabel>
                      <InputContainer>
                        <input
                          className="uk-input input"
                          type="text"
                          value={NomeFiltro}
                          onChange={e => setNomeFiltro(e.target.value)}
                        />
                      </InputContainer>
                    </Section>

                    <Section className="uk-width-1-4@m">
                      <InputContainer>
                        <FormLabel className="uk-form-label">CPF </FormLabel>
                        <InputMask mask="999.999.999-99" maskChar=" " value={CPFFiltro} onChange={(e) => setCPFFiltro(e.target.value)}>
                          {() => (<input type="text" className="uk-input input" placeholder='' />)}
                        </InputMask>                                              
                      </InputContainer>
                    </Section>

                    <Section className="uk-width-1-6@m">
                      <InputContainer>
                        <FormLabel className="uk-form-label">Data de cadastro (De)</FormLabel>
                        <input                                   
                            className="uk-input input"
                            type="date"
                            value={DataCadInicio}                    
                            onChange={e => setDataCadInicio(e.target.value)}
                          />                                               
                      </InputContainer>
                    </Section> 

                    <Section className="uk-width-1-6@m">
                      <InputContainer>
                        <FormLabel className="uk-form-label">Data de cadastro (Até)</FormLabel>
                        <input                                   
                            className="uk-input input"
                            type="date"
                            value={DataCadTermino}                    
                            onChange={e => setDataCadTermino(e.target.value)}
                          />                                               
                      </InputContainer>
                    </Section> 

                    <Section className="uk-width-1-6@m">
                      <InputContainer>
                        <FormLabel className="uk-form-label">Status</FormLabel>  
                          <Select           
                            defaultValue={StatusFiltro}
                            onChange={setStatusFiltro}
                            options={ListaStatus}                                            
                            placeholder={"..."}
                            isLoading={!ListaStatus.length}
                            className="basic-multi-select" 
                            classNamePrefix="uk-select"                                                                              
                          />  
                      </InputContainer>
                    </Section>

                    {/* <Section className="uk-width-1-5@m">
                      <InputContainer>
                        <FormLabel className="uk-form-label">Tipo</FormLabel>
                          <Select
                            defaultValue={TipoFiltro}
                            onChange={setTipoFiltro}
                            options={ListaTipo}
                            placeholder={"..."}
                            isLoading={!ListaTipo.length}
                            className="basic-multi-select"
                            classNamePrefix="uk-select"
                          />  
                      </InputContainer>
                    </Section> */}

                  </Grid>                              
                </CardBody>
              
                <CardFooter>
                  <Grid className="uk-grid-small uk-flex uk-flex-right">
                    <Section>
                      <button
                        type="button"                                            
                        id="Filtrar" 
                        className="uk-button uk-button-primary uk-float-right"                          
                        onClick={() => {GetListaUsuarios("Filtrar", "aguardeFiltro"); SetCurrentPage(1)}}        
                        value="Filtrar"   
                        //disabled={blockFiltro}                   
                      > 
                      <span  uk-icon="icon: search"></span> 
                        Filtrar                                        
                      </button>  

                      <button className="uk-button uk-button-primary" id="aguardeFiltro" style={{display:'none'}}>
                        <span uk-spinner="ratio: 0.5" className="uk-margin-small-right"></span> Aguarde
                      </button>  

                    </Section>
                  </Grid>                                                           
                </CardFooter> 
              </Card>                
            
              {
                AlertMsg === true &&
                <Alert color={color} content={msg}  duration={time} onHide={() => SetAlertMsg(false)} isClosable />
              } 

              <Card className="uk-card-default uk-margin">

                  <CardHeader>
                    <Grid className="uk-flex uk-flex-middle">
                      <Section className="uk-width-expand">
                        <h4 className="uk-card-title">Lista de Usuários</h4>
                      </Section>
					
                      <Section className="uk-width-auto">
                        <Grid className="uk-flex uk-flex-right">
                          <Section>
                            <button className="uk-button uk-button-link" type="button" onClick={() => AbreModalCadastroUsuario()}>
                              <span uk-icon="icon: plus-box"></span>  Novo Usuário
                            </button>
                          </Section>
                          <Section>
                            {LoadingExportar ?
                            <button className="uk-button uk-button-link" type="button" disabled="disabled"><span uk-spinner="ratio: 0.5" className="uk-margin-small-right"></span> Aguarde</button>
                            :
                            <button className="uk-button uk-button-link" type="button" onClick={() => ExportarDados()}> <span uk-icon="icon: cloud-download"></span> Exportar </button>
                            }
                          </Section>
                        </Grid>
                      </Section>
                    </Grid>
                  </CardHeader>

                  {
                    !ListaUsuario ?
						<CardBody>
							<Loading />
						</CardBody> 
                    :
						<>
							<CardBody className="uk-child-width-expand@s uk-padding-small">
								<Section className="uk-margin-remove uk-padding-small uk-padding-remove-left uk-padding-remove-right">
									<div className="uk-overflow-auto">
										<table className="uk-table uk-table-divider uk-table-striped uk-table-small uk-text-small uk-table-middle  uk-table-hover">                                        
											<thead>
												<tr>  
													<th className="uk-text-left uk-table-expand">Nome</th> 
													<th className="uk-text-left uk-table-expand">CPF</th> 
													<th className="uk-text-left uk-table-expand">E-mail</th> 
													<th className="uk-text-left uk-table-expand">Celular</th> 
													<th className="uk-text-left uk-table-shrink">Status</th> 
													<th className="uk-text-left uk-table-shrink">Tipo</th> 
													<th className="uk-text-left uk-table-expand">Data Cadastro</th> 
													<th className="uk-text-center uk-table-shrink">Ação</th> 
												</tr>
											</thead>                              
										<tbody>  
										{
											ListaUsuario.length > 0 ?                              
												ListaUsuario.map((camp, i) => {                                      

													return(                                
														<tr key={i}> 
															<td className="uk-text-nowrap">                                        
																<strong>{camp.nome}</strong>
																{/* <small className="uk-text-muted"><strong>Função:</strong> {camp.profissaoDescricao}</small>
																<small><strong>Email:</strong> {camp.email}</small> */}
															</td>  		
															<td className="uk-text-nowrap">{mascaraCPF(camp.documento)}</td>
															<td className="uk-text-nowrap">{camp.email}</td>
															<td className="uk-text-nowrap">{camp.celularDDD} {camp.celular}</td>
															<td>
																{ camp.statusId === 2476  && <span className="uk-label uk-label-success uk-text-capitalize">Ativo</span> }
																{ camp.statusId === 23013 && <span className="uk-label uk-label-primary uk-text-capitalize">Pré-Cadastro</span> }
																{ camp.statusId === 6387  && <span className="uk-label uk-label-danger uk-text-capitalize">Bloqueado</span> } 											
															</td> 
															<td className="uk-text-nowrap">{camp.profissaoDescricao}</td>
															<td className="uk-text-nowrap">{DateFormatTNew(camp.dataCad)}</td>
															<td className="uk-text-nowrap">
                                {documento.replace(/\D/g, "") === camp.documento ? <button className="uk-icon-button" uk-icon="icon: minus" disabled /> :
																<>
																  {(camp.statusId === 2476 || camp.statusId === 23013) && <button className="uk-icon-button" uk-icon="icon: ban" uk-tooltip="title: Bloquear" onClick={() => AbreModalStatusUsuario(camp)} />}
  																{camp.statusId === 6387  && <button className="uk-icon-button" uk-icon="icon: unlock" uk-tooltip="title: Desbloquear" onClick={() => AbreModalStatusUsuario(camp)} />}
																</>
                                }
                              </td>
														</tr>
													) 
												})
											:
												<tr className="uk-text-center">
													<td colSpan={10}>
													{mensagem}
													</td>
												</tr>
										}                                        
										</tbody>
									</table>
									</div>                          
								</Section>                    
							</CardBody>                          
							{
								ListaUsuario.length > 0 &&  
								<CardFooter>
									<Grid className="uk-grid-small uk-flex uk-flex-middle uk-flex-right">
									<>
										<Section className="uk-flex uk-flex-middle">                      
										<span className="uk-margin-small-right">Itens por Página:</span>
										<InputContainer className="uk-form-controls">
											<select className="uk-select" id="form-horizontal-select" onChange={(e) => {SetItensPerPage(e.target.value); SetCurrentPage(1)}}>
												<option value={25} selected={itensPerPage === "25" ? "selected" : ""}>25</option>
												<option value={50} selected={itensPerPage === "50" ? "selected" : ""}>50</option>
												<option value={75} selected={itensPerPage === "75" ? "selected" : ""}>75</option>   
												<option value={100} selected={itensPerPage === "100" ? "selected" : ""}>100</option>                                        
											</select>
										</InputContainer>
										</Section>

										<Section>
										<>                                  
										

										<ReactPaginate
												nextLabel=" >"                                  
												onClick={(e) => MudaPaginaItens(e)}                                         
												pageRangeDisplayed={3}
												marginPagesDisplayed={1}
												forcePage={currentPage - 1}
												pageCount={pageCount}
												hrefAllControls={true}
												previousLabel="< "
												pageClassName="page-item"
												pageLinkClassName="page-link"
												previousClassName="page-item"
												// previousLinkClassName="page-link"
												nextClassName="page-item"
												// nextLinkClassName="page-link"
												breakLabel="..."
												breakClassName="page-item"
												breakLinkClassName="page-link"
												containerClassName="uk-pagination"
												activeClassName="uk-active"
												renderOnZeroPageCount={null}
											/>
										</>
										</Section>
									</> 
									</Grid>                                   
								</CardFooter>
							}
						</>
                  }
              </Card>
        
          </Section>
        </main>
      </Container>  


        <Modal isOpen={ModalAlteraStatus} centered id="sm">
          <ModalHeader>{'Alteração de Status'}</ModalHeader>

          <ModalBody>         
            <p className="uk-margin-bottom">Tem certeza que deseja alterar o status do administrador <strong>{DadosUsuario?.nome}</strong>?</p>  
          </ModalBody>

          <ModalFooter>
            <Grid className="uk-grid-small uk-flex uk-flex-right">
              <Section>
                <button type="button" className="uk-button uk-button-default" onClick={() => FechaModalStatusUsuario()}>
                  <span uk-icon="icon: close"></span> Cancelar
                </button>
              </Section>
              <Section>
                  <button type="button" id="deletar" className="uk-button uk-button-primary" onClick={() => AlterarStatusUsuario(DadosUsuario)}>
                    <span uk-icon="icon: check"></span> SIM! Alterar Status
                  </button>      
                          
                  <button className="uk-button uk-button-primary" id="aguardeDelet" style={{display:'none'}} disabled>
                    <span uk-spinner="ratio: 0.5" className="uk-margin-small-right"></span> Aguarde
                  </button>
                </Section>
            </Grid>
          </ModalFooter>
        </Modal>

        <Modal isOpen={ModalCadastroUsuario} id="lg" centered>
          <ModalHeader>Cadastro</ModalHeader>
  
          <ModalBody>
  
            <Grid className="uk-grid-small">

              <Section className="uk-width-1-1@m">
                  <FormLabel className="uk-form-label">Tipo de cadastro <span className="uk-text-danger">*</span></FormLabel>
                <InputContainer>
                {ListaTipo.length > 0 && 
                  ListaTipo.map((item, index) => {
                    return (
                      <label for={item.ProdissaoId} key={index} className="uk-margin-small-right">
                        <input
                          type={'radio'}
                          className={'uk-radio'}
                          id={item.ProdissaoId}
                          value={item.ProdissaoId}
                          checked={DadosCadastro?.profissao === item.ProdissaoId.toString() ? true : false}
                          onChange={e => setDadosCadastro({ ...DadosCadastro, profissao: e.target.value })}
                        /> {item.ProfissaoDescricao}
                      </label>
                    )
                  })}
                </InputContainer>
              </Section>
  
              <Section className="uk-width-1-2@m">
                <InputContainer>
                  <FormLabel className="uk-form-label">Nome <span className="uk-text-danger">*</span></FormLabel>
                  <input
                    className="uk-input input"
                    placeholder='Informe o Nome'
                    type="text"
                    value={DadosCadastro?.nome || ''}
                    onChange={e => setDadosCadastro({ ...DadosCadastro, nome: e.target.value })} />
                </InputContainer>
              </Section>
  
              <Section className="uk-width-1-2@m">
                <InputContainer>
                  <FormLabel className="uk-form-label">CPF <span className="uk-text-danger">*</span></FormLabel>
                  <InputMask 
                    mask="999.999.999-99" 
                    maskChar=" " 
                    value={DadosCadastro?.cpf || ''}
                    onChange={e => setDadosCadastro({ ...DadosCadastro, cpf: e.target.value })} >                 
                    {() => (<input type="text" className="uk-input input" placeholder='Informe o CPF' />)}
                  </InputMask>
                </InputContainer>
              </Section>  
  
              <Section className="uk-width-1-2@m">
                <InputContainer>
                  <FormLabel className="uk-form-label">E-mail <span className="uk-text-danger">*</span></FormLabel>
                  <input
                    className="uk-input input"
                    placeholder='Informe o E-mail'
                    type="text"
                    value={DadosCadastro?.email || ''}
                    onChange={e => setDadosCadastro({ ...DadosCadastro, email: e.target.value })}
                  />
                </InputContainer>
              </Section>
  
              <Section className="uk-width-1-2@m">
                <InputContainer>
                  <FormLabel className="uk-form-label">Telefone <span className="uk-text-danger">*</span></FormLabel>
                  <InputMask mask="(99) 999999999" maskChar=" " value={DadosCadastro?.telefone || ''} onChange={e => setDadosCadastro({ ...DadosCadastro, telefone: e.target.value })} >
                    {() => (<input type="text" className="uk-input input" placeholder='Informe o Telefone' />)}
                  </InputMask>
                </InputContainer>
              </Section>
  
              {/* <Section className="uk-width-1-2@m">
                <InputContainer>
                  <FormLabel className="uk-form-label">Cargo <span className="uk-text-danger">*</span></FormLabel>
                  <select className="uk-select" value={cargo} onChange={(e) => setCargo(e.target.value)}>
                    <option value="">...</option>
                    {listaCargos.map(cargo => (
                      <option key={cargo.chave} value={cargo.chave}>{cargo.valor}</option>
                    ))}
                  </select>
                </InputContainer>
              </Section> */}
      
            </Grid>
          </ModalBody>
  
          <ModalFooter>
            <Grid className="uk-grid-small uk-flex uk-flex-right">
              <Section>
                <button
                  type="button"
                  id='btn-fechar-cadastro'
                  className="uk-button uk-button-danger"
                  onClick={() => { FechaModalCadastroUsuario() }}
                >
                  <span uk-icon="icon: close"></span> Fechar
                </button>
              </Section>
              <Section>
                <button
                  type="button"
                  id="btn-envia-formulario"
                  className="uk-button uk-button-primary"
                  onClick={() => CadastrarUsuario()}
                >
                  <span uk-icon="icon: check"></span> Cadastrar
                </button>
  
                <button className="uk-button uk-button-primary" id="btn-envia-formulario-loading" >
                  <span uk-spinner="ratio: 0.5" className="uk-margin-small-right"></span> Aguarde
                </button>
              </Section>
            </Grid>
          </ModalFooter>
        </Modal>

    </Cont>
  );
}

export default Usuarios;
